import { DadosAutenticacao } from "./dadosAutenticacao";

export interface Pedido {
  id: string;
  IdUnit?: string;
  IdCliente?: string;
  IdEntregador?: number;
  DataHora?: string;
  Pedido?: any;
  status?: string;
  TempoEntrega?: number;
  Hash?: string;
  Versao?: string;
  TempoRestante?: number;
  Atualizacao?: number;
  Progresso?: number;
  TimestampAgendamento?: number;
  Mesa?: number;
  Comanda?: number;
  ComandaLocal?: string;
  NomeLoja?: string;
}

export enum StatusMovimentacao {
  PENDENTE = "PENDENTE",
  SUCESSO = "SUCESSO",
}

export enum StatusPedido {
  PENDENTE = 1,
  EM_PRODUCAO = 2,
  ENTREGRANDO = 3,
  FINALIZADO = 4,
  CANCELADO = 5,
  AGENDADO = 6,
}

export class TStatusPedido {
  static PENDENTE = 1;
  static EM_PRODUCAO = 2;
  static ENTREGRANDO = 3;
  static FINALIZADO = 4;
  static CANCELADO = 5;
  static AGENDADO = 6;

  public status: number;

  constructor(status: number | string) {
    this.status = Number(status);
  }

  toNumber() {
    return this.status;
  }

  toString() {
    return String(this.status);
  }

  next(): TStatusPedido {
    const nextStatus = [];
    nextStatus[1] = 2;
    nextStatus[2] = 3;
    nextStatus[3] = 4;
    nextStatus[6] = 2;
    return !!nextStatus?.[this.status]
      ? new TStatusPedido(nextStatus[this.status])
      : null;
  }

  prev(): TStatusPedido {
    const prevStatus = [];
    prevStatus[2] = 1;
    prevStatus[3] = 2;
    prevStatus[4] = 3;
    return !!prevStatus?.[this.status]
      ? new TStatusPedido(prevStatus[this.status])
      : null;
  }

  is(status: number | string | StatusPedido) {
    return Number(status) === Number(this.status);
  }

  in(status = []) {
    status = status.map((item) => Number(item));
    return status.includes(Number(this.status));
  }
}

export function getTimestampDataAgendamentoPedido(order: Pedido) {
  if (!order?.Pedido?.DadosAgendamento?.Data) {
    return 0;
  }

  const dados = order?.Pedido?.DadosAgendamento ?? {};
  const data = dados?.Data + " " + dados?.Hora + ":00";
  const parts = data.match(/\d+/g);

  if (parts?.length < 6) {
    return 0;
  }

  const [ano, mes, dia, hora, minutos, segundos] = parts;
  return new Date(
    `${mes}/${dia}/${ano} ${hora}:${minutos}:${segundos}`
  ).getTime();
}

export function getTimestampDataHoraPedido(order: Pedido) {
  if (!order?.DataHora) {
    return null;
  }

  const parts = order.DataHora.match(/\d+/g);

  if (parts.length < 6) {
    return null;
  }

  const [ano, mes, dia, hora, minutos, segundos] = parts;
  return new Date(
    `${mes}/${dia}/${ano} ${hora}:${minutos}:${segundos}`
  ).getTime();
}

export function getMinutesBetweenDates(d0: number, d1: number) {
  const x0 = new Date(d0).getTime();
  const x1 = new Date(d1).getTime();
  return Math.round((x0 - x1) / 60000);
}

export interface RetornoAtualizacaoStatusPedidoItem {
  id: string;
  Status: string;
  Atualizacao: string;
}

export interface RetornoAcaoLimparColunaItem {
  id: string;
  Status: string;
  ExibirMonitor: string;
  Atualizacao: string;
}

export interface RetornoAtualizacaoStatusPedido {
  Status: string;
  StatusPedidos: RetornoAtualizacaoStatusPedidoItem[];
}

export interface RetornoAcaoLimparColuna {
  StatusPedidos: RetornoAcaoLimparColunaItem[];
}

export type RetornoPedidosDoDia = DadosAutenticacao & PedidosDoDia;

export interface PedidosDoDia {
  Pedidos: Pedido[];
}

export interface RetornoNovosPedidos {
  Pedidos: Pedido[];
  Atualizacao: RetornoNovosPedidosAtualizacao[];
}

export interface RetornoNovosPedidosAtualizacao {
  id: string;
  status: string;
  IdEntregador: string;
  Atualizacao: string;
}
